module.exports = "<nv-page [pageParams]=\"pageParams\"\n                   [collectionParams]=\"collectionParams\" >\n  <div *ngIf=\"document\">\n    <div class=\"row\">\n      <div class=\"col-md-5\">\n        <nv-input [document]=\"document\"\n                  [pointer]=\"'/name'\"\n                  [size]=\"8\"\n                  [label]=\"'Имя'\"></nv-input>\n      </div>\n    </div>\n  </div>\n</nv-page>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/pages/atlases/atlases-page.component.html
// module id = ../../../../../src/app/pages/atlases/atlases-page.component.html
// module chunks = 0